/**
 * German PLZ lookup via public.opendatasoft.com was removed: unreliable (SSL / availability).
 * PLZ/Ort fields use vue-select with `taggable` so values can be entered manually (confirm with Enter).
 */
export function clearPlzAddressOptions(component) {
  component.addresses.postcode = []
  component.addresses.city = []
  component.addresses.street = []
}
